import { ConfigMurucaHomeLayout } from '@net7/boilerplate-muruca';

export default {
  title: 'Home',
  bodyClasses: '',
  sections: [
    {
      id: 'hero-main',
      type: 'hero',
      grid: null,
      options: {
        classes: 'n7-hero-main',
        background: true
      }
    },
    // {
    //   id: 'content-img',
    //   type: 'hero',
    //   grid: null,
    //   options: {
    //     classes: 'n7-hero-works',
    //     background: true,
    //   },
    // },
    {
      id: 'content-main',
      type: 'hero',
      grid: null,
      options: {
        classes: 'n7-hero-works',
        background: true,
      },
    },
    // {
    //   id: 'slider-main',
    //   type: 'slider',
    //   grid: null,
    //   options: {
    //     classes: 'n7-slider-main',
    //     background: true,
    //   },
    // },
    // {
    //   id: 'collection-works',
    //   type: 'collection',
    //   grid: 4,
    //   options: {
    //     classes: 'is-vertical'
    //   }
    // },
    // {
    //   id: 'hero-books',
    //   type: 'hero',
    //   grid: null,
    //   options: {
    //     classes: 'n7-hero-books',
    //     background: false
    //   }
    // },
    /* {
      id: 'timeline-events',
      type: 'timeline',
      grid: null
    }, */
    // {
    //   id: 'collection-tours',
    //   type: 'collection',
    //   grid: 4,
    //   options: {
    //     classes: 'is-overlay'
    //   }
    // },
    // {
    //   id: 'collection-news',
    //   type: 'collection',
    //   grid: 4,
    //   options: {
    //     classes: 'is-vertical',
    //   },
    // },
  ],
} as ConfigMurucaHomeLayout;
